import { Button, CardMedia, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import FormKeyword from "../form/FormKeyword";
import { IFormEvent } from "../form/Form.interface";
import Util, { fetchImgs } from "../services/util";
import axios from "axios";
import DataCommon from "../ui/DataCommon";
import FormSelect from "../form/FormSelect";
import NewsForm from "./NewsForm";
import { Status } from "../common/config";
import { Add } from "@mui/icons-material";
import { format } from "date-fns";
import { title } from "process";

export default function News() {
  const [query, setQuery] = React.useState({ limit: 20, skip: 0, keyword: '', channel: '', tags: '', status: -1 })
  const [data, setData] = React.useState<{ count: number, data: any[] }>()
  const [channelOption, setChannelOption] = React.useState<any>([])
  const [tagOption, setTagOption] = React.useState<any>([])
  const [form, setForm] = React.useState<any>()

  function handleQueryChange(e: IFormEvent) {
    setQuery(Util.formChange(e, query))
  }

  function find() {
    axios.post('cms/newslist', { ...query, status: query.status === -1 ? undefined : query.status }).then(({ data }) => {
      data.data.forEach((i: any) => {
        i.newimg = Array.from(new Set([i.newimg, ...fetchImgs(i.text)].filter(i => !!i)))
      })
      setData(data)
    })
  }

  React.useEffect(() => {
    axios.post('cms/channelsIndex', {}).then(({ data }) => {
      setChannelOption(data)
    })
    axios.post('cms/tagsIndex', {}).then(({ data }) => {
      setTagOption(data)
    })
  }, [])


  React.useEffect(find, [query])

  return <Stack sx={{ ml: 1 }} >
    <Stack direction="row" sx={{ mt: 2, mr: 2 }} spacing={2} alignItems={"center"}>
      <FormKeyword name={"keyword"} value={query.keyword} label={"搜"} onChange={handleQueryChange} />
      <FormSelect label="频道" name="channel" value={query.channel} onChange={handleQueryChange}
        options={[{ title: '全部', value: '' }, ...channelOption]} />
      <FormSelect label="标签" name="tags" value={query.tags} onChange={handleQueryChange}
        options={[{ title: '全部', value: '' }, ...tagOption]} />
      <FormSelect label="状态" name="status" value={query.status} onChange={handleQueryChange}
        options={[{ title: '全部', value: -1 }, ...Status.newsAudit.map((i, index) => ({ title: i, value: index }))]} />
      <Stack flexGrow={1}></Stack>
      <Button variant="contained" startIcon={<Add />} onClick={() => setForm({
        channel: '', pubDate: format(new Date(), 'yyyy-MM-dd HH:mm:ss'), source: '',
        title:'',
        tags:[],
        body: [{ type: "p", value: '' }],
        _id: '',
        _audit: { status: 0, description: [] }
      })}>添加</Button>
    </Stack>

    <Stack>
      {(!!data?.data.length) && <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>频道</TableCell>
            <TableCell>标题</TableCell>
            <TableCell>题图</TableCell>
            <TableCell>发布日期</TableCell>
            <TableCell>审核</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.data.map((i, idnex) => <TableRow hover key={idnex} sx={{ td: { p: .5 } }} onClick={() => {
            setForm(i)
          }}>
            <TableCell>{i._id}</TableCell>
            <TableCell>
              <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>{i.channel}</Typography>
              <br />
              <Typography variant="caption">{i.tags.join(', ')}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{i.title}</Typography>

            </TableCell>
            <TableCell>
              {i.newimg[0] && <CardMedia
                component="img"
                sx={{ height: 40 }}
                image={i.newimg[0]}
              />}
            </TableCell>
            <TableCell>{i.pubDate}</TableCell>
            <TableCell >
              <Typography color={Status.color[i._audit.status]}>
                {Status.newsAudit[i._audit.status]}

              </Typography>
            </TableCell>
          </TableRow>)}
        </TableBody>
      </Table>}
      <DataCommon data={data} query={query} setQuery={setQuery} />
    </Stack>
    {form && <NewsForm form={form} onClose={(e: any) => {
      if (e) {
        find()
      }
      setForm(undefined)
    }} />}
  </Stack>
}